import type { PublicUser } from "@mk/shared";
import { messages } from "../i18n/index.ts";

/** The entitlement badge is presentation data, never part of the username. */
export function UserName({ user }: { user: PublicUser }) {
  return <><span className="username">{user.username}</span>{user.removeAds && <span className="ml-1 text-yellow-400" role="img" aria-label={messages.profile.supporter}>★</span>}</>;
}
